import { useMutation } from 'react-query';

// app
import { quoteBindAxios } from 'lib/quoteBind';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';
import { file } from 'utils';

export const useDownloadRiskDocument = () => {
  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.queries.useDownloadRiskDocument',
    };

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = ({ data, fileName }) => {
    file.fileSaver(data, fileName);
  };

  return useMutation(
    async ({ riskId, documentId, fileName }) => {
      const { data } = await quoteBindAxios.get(`/risks/${riskId}/documents/${documentId}`, {
        responseType: 'blob',
        timeout: 30000,
      });
      return { data, fileName };
    },
    {
      onError: (err) => handleError(err),
      onSuccess: (res) => handleSuccess(res),
    }
  );
};
